import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { useMemo } from "react";

export interface TrailTireInfoModel {
    productNumber: string;
    canadianTireNumber: string;
    retailPrice: number;
    orderDepot: boolean;
    notAvailable: boolean;
}

export interface TrailTireInfoViewModel extends TrailTireInfoModel, Data {}

interface DataCollection {
    orderDepot: Data;
    notAvailable: Data;
}

interface Data {
    class?: string;
    translate?: string;
}

export const useTrailTireInfo = (product: ProductModel) => {
    const trailTireInfo = product?.properties?.trailTireInfo;

    const data: DataCollection = {
        orderDepot: {
            class: "order-depot",
            translate: translate("Order from Depot"),
        },
        notAvailable: {
            class: "not-avail",
            translate: translate("Not Avail. Sku"),
        },
    };

    return useMemo<TrailTireInfoViewModel | null>(() => {
        if (trailTireInfo) {
            /* eslint-disable no-empty */
            try {
                const parsedData = JSON.parse(trailTireInfo) as TrailTireInfoModel;
    
                /* eslint-disable no-else-return */
                if (parsedData.orderDepot) {
                    return { ...parsedData, ...data.orderDepot };
                } else if (parsedData.notAvailable) {
                    return { ...parsedData, ...data.notAvailable };
                }
    
                return { ...parsedData };
            } catch (error) {}
        }
    
        return null;
    }, [trailTireInfo]);
};

